import { createBrowserRouter, Navigate } from 'react-router-dom'

import { AdminLayout } from './admin/layout'
import { AdminOverviewPage } from './admin/page'
import { AdminTenantDetailPage } from './admin/tenants/detail/page'
import { AdminTenantsPage } from './admin/tenants/page'
import { AdminUsagePage } from './admin/usage/page'
import { AdminUsersPage } from './admin/users/page'
import { ConfirmEmailPage } from './confirm-email/page'
import { AnalyticsPage } from './dashboard/analytics/page'
import { AutomationPage } from './dashboard/automation/page'
import { BillingPage } from './dashboard/billing/page'
import { BrandPage } from './dashboard/brand/page'
import { ClientsPage } from './dashboard/clients/page'
import { CompetitorsPage } from './dashboard/competitors/page'
import { ContentBriefsPage } from './dashboard/content-briefs/page'
import { LookerStudioPage } from './dashboard/integrations/looker/page'
import { IntegrationsPage } from './dashboard/integrations/page'
import { DashboardLayout } from './dashboard/layout'
import { PromptsPage } from './dashboard/prompts/page'
import { RecommendationsPage } from './dashboard/recommendations/page'
import { ReportsPage } from './dashboard/reports/page'
import { SchemaGeneratorPage } from './dashboard/schema-generator/page'
import { ScorePage } from './dashboard/score/page'
import { SettingsLayout } from './dashboard/settings/layout'
import { SettingsPage } from './dashboard/settings/page'
import { SimulatorPage } from './dashboard/simulator/page'
import { SourcesPage } from './dashboard/sources/page'
import { TeamPage } from './dashboard/team/page'
import { WebsitesPage } from './dashboard/websites/page'
import { InvitePage } from './invite/page'
import { LoginPage } from './login/page'
import { ProtectedLayout } from './protected-layout'
import { ResetPasswordPage } from './reset-password/page'
import { SignupCompletePage } from './signup/complete-page'
import { SignupPage } from './signup/page'

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/signup',
    element: <SignupPage />,
  },
  {
    path: '/signup/complete',
    element: <SignupCompletePage />,
  },
  {
    path: '/invite',
    element: <InvitePage />,
  },
  {
    path: '/confirm-email',
    element: <ConfirmEmailPage />,
  },
  {
    path: '/reset-password',
    element: <ResetPasswordPage />,
  },
  {
    path: '/',
    element: <ProtectedLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard" replace />,
      },
      {
        path: 'dashboard',
        element: <DashboardLayout />,
        children: [
          { index: true, element: <ScorePage /> },
          { path: 'prompts', element: <PromptsPage /> },
          { path: 'competitors', element: <CompetitorsPage /> },
          { path: 'automation', element: <AutomationPage /> },
          { path: 'recommendations', element: <RecommendationsPage /> },
          { path: 'sources', element: <SourcesPage /> },
          { path: 'reports', element: <ReportsPage /> },
          { path: 'schema-generator', element: <SchemaGeneratorPage /> },
          { path: 'content-briefs', element: <ContentBriefsPage /> },
          { path: 'analytics', element: <AnalyticsPage /> },
          { path: 'simulator', element: <SimulatorPage /> },
          {
            path: 'settings',
            element: <SettingsLayout />,
            children: [
              { index: true, element: <SettingsPage /> },
              { path: 'team', element: <TeamPage /> },
              { path: 'clients', element: <ClientsPage /> },
              { path: 'websites', element: <WebsitesPage /> },
              { path: 'mcp', element: <IntegrationsPage /> },
              { path: 'looker', element: <LookerStudioPage /> },
              { path: 'brand', element: <BrandPage /> },
              { path: 'billing', element: <BillingPage /> },
            ],
          },
          // Old top-level paths → new nested settings routes (bookmarks, browser history)
          { path: 'team', element: <Navigate to="/dashboard/settings/team" replace /> },
          { path: 'clients', element: <Navigate to="/dashboard/settings/clients" replace /> },
          { path: 'websites', element: <Navigate to="/dashboard/settings/websites" replace /> },
          { path: 'integrations', element: <Navigate to="/dashboard/settings/mcp" replace /> },
          { path: 'integrations/looker', element: <Navigate to="/dashboard/settings/looker" replace /> },
          { path: 'brand', element: <Navigate to="/dashboard/settings/brand" replace /> },
          { path: 'billing', element: <Navigate to="/dashboard/settings/billing" replace /> },
        ],
      },
      {
        path: 'admin',
        element: <AdminLayout />,
        children: [
          { index: true, element: <AdminOverviewPage /> },
          { path: 'tenants', element: <AdminTenantsPage /> },
          { path: 'tenants/:id', element: <AdminTenantDetailPage /> },
          { path: 'users', element: <AdminUsersPage /> },
          { path: 'usage', element: <AdminUsagePage /> },
        ],
      },
    ],
  },
  // Catch-all → dashboard
  {
    path: '*',
    element: <Navigate to="/dashboard" replace />,
  },
])
